import {useLocation} from 'react-router-dom';
import {ReactNode} from 'react';

export interface IEditOnlyCompParams {
  children: ReactNode | ReactNode[];
  // eslint-disable-next-line react/no-unused-prop-types
  isEdit?: boolean;
}

export const EditOnlyComp = ({children, isEdit}: IEditOnlyCompParams) => {
  const location = useLocation();
  return location.pathname.includes('edit') || isEdit ? <>{children}</> : null;
};

export const AddOnlyComp = ({children}: IEditOnlyCompParams) => {
  const location = useLocation();
  return !location.pathname.includes('edit') ? <>{children}</> : null;
};
